import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var MaintenanceTypeService = /** @class */ (function () {
    function MaintenanceTypeService(apollo) {
        this.apollo = apollo;
    }
    MaintenanceTypeService.prototype.listMaintenanceTypes = function (_a) {
        var where = _a.where, _b = _a.orderBy, orderBy = _b === void 0 ? 'name_asc' : _b, _c = _a.limit, limit = _c === void 0 ? 100 : _c, _d = _a.offset, offset = _d === void 0 ? 0 : _d;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_e) {
                query = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query listMaintenanceTypes(\n        $where: MaintenanceTypeWhereInput,\n        $orderBy: MaintenanceTypeOrderByInput,\n        $limit: Int,\n        $offset: Int\n      ) {\n        maintenanceTypes( where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {\n          items {\n            id\n            name\n            type\n            archived\n          }\n        }\n      }\n    "], ["\n      query listMaintenanceTypes(\n        $where: MaintenanceTypeWhereInput,\n        $orderBy: MaintenanceTypeOrderByInput,\n        $limit: Int,\n        $offset: Int\n      ) {\n        maintenanceTypes( where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {\n          items {\n            id\n            name\n            type\n            archived\n          }\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo.query({
                        query: query,
                        variables: {
                            where: where,
                            orderBy: orderBy,
                            limit: limit,
                            offset: offset
                        }
                    })
                        .toPromise()
                        .then(function (result) {
                        return result.data['maintenanceTypes']['items'];
                    })];
            });
        });
    };
    MaintenanceTypeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MaintenanceTypeService_Factory() { return new MaintenanceTypeService(i0.ɵɵinject(i1.Apollo)); }, token: MaintenanceTypeService, providedIn: "root" });
    return MaintenanceTypeService;
}());
export { MaintenanceTypeService };
var templateObject_1;
